export const DEFAULT_ROUTE_OPTIONS = [
  { label: "My Work", value: "my-work", suffix: "/my-work" },
  { label: "Inbox", value: "inbox", suffix: "/inbox" },
  { label: "Workflows", value: "workflows", suffix: "/workflows" },
  { label: "Teams", value: "teams", suffix: "/teams" },
  { label: "Map", value: "Map", suffix: "/map" },
] as const;

/**
 * The landing route for a user who has not chosen one. Both the workspace-root
 * redirect and the Preferences picker read this, so they can never disagree.
 */
export const DEFAULT_ROUTE_VALUE: (typeof DEFAULT_ROUTE_OPTIONS)[number]["value"] = "my-work";

/**
 * Workspace-relative suffix for a user's chosen landing route. An unknown or
 * retired value falls back to `DEFAULT_ROUTE_VALUE`.
 */
export function getDefaultRouteSuffix(route: string | null | undefined): string {
  const match = DEFAULT_ROUTE_OPTIONS.find((r) => r.value === route);
  if (match) return match.suffix;
  const fallback = DEFAULT_ROUTE_OPTIONS.find((r) => r.value === DEFAULT_ROUTE_VALUE);
  if (!fallback) throw new Error(`Unknown default route "${DEFAULT_ROUTE_VALUE}"`);
  return fallback.suffix;
}
